import { bl_fi_report_section_gl_category_link_RowClass } from '../../../dbschema/bl_fi_report_section_gl_category_link.model';
import {BaseContainerModel} from '../../base-container.model';


export class GLSectionCategoryLinkContainerModel extends BaseContainerModel {
  bl_fi_report_section_gl_category_link: bl_fi_report_section_gl_category_link_RowClass = new bl_fi_report_section_gl_category_link_RowClass();
}
